import { FeatureFlagsContext } from "./FeatureFlagContext";
import { useUniversalContext } from "../UniversalContext";

export function useFeatureFlags() {
  const flags = useUniversalContext<{ [key: string | symbol]: any }>(
    FeatureFlagsContext,
  );

  return new Proxy<{ [key: string]: boolean }>(
    {},
    {
      get(target, prop) {
        if (flags[prop]) {
          return flags[prop].enabled;
        }
        return false;
      },
    },
  );
}
